import setHeaderOffset from '../../../../../../../Project/MainSite/code/Scripts/mainsiteUtils.js';
import signInProgress from '../../../../Scripts/signInProgress.js';

/*jshint esversion: 6 */
// Homepage + offsets ------------------------------------
$(document).ready(function () {

    if (!$("body").hasClass("home-page")) {
        $("header.desktop").addClass("fill");
        $("header.desktop .logo").addClass("color");
    }

    //add attributes for various paths
    $(".signin").attr("href", HeaderData.signInPath);
    $(".signout").attr("href", HeaderData.signOutPath);
    $(".cartpath").attr("href", HeaderData.cartPath);

    // Show the slim sign-in progress bar through the SSO bounce. initOnLoad keeps
    // it visible across the multi-hop redirect and dismisses it once authenticated.
    signInProgress.initOnLoad();
    $("body").on("click", ".signin", function () {
        signInProgress.start();
    });

    var searchClass = $(".hide-global-search");

    if (searchClass && searchClass.length) {
        //target global searchbox and display:none
        $(".search-wrap").css("display", "none");
    }
    setHeaderOffset();
});


// Navigation ------------------------------------
function openNav() {
    document.getElementById("fsNav").style.left = "0px";
    document.body.style.overflow = "hidden";
    $(".openNav").toggleClass('burger no-burger'); // Mobile
    $(".closeNav").toggleClass('no-x x'); // Mobile

    document.getElementById("closeNavId").tabIndex = 0;
    for (var i = 0; i < $(".navSection").length; i++) {
        $(".navSection")[i].tabIndex = 0;
    }
    for (var j = 0; j < $(".subDirectLink").length; j++) {
        $(".subDirectLink")[j].tabIndex = 0;
    }
}

function openUtilityNav() {
    var dropdown = $(this.parentNode).find(".dropdown");
    var accountWrap = $(this.parentNode);

    if (dropdown.css('display') == 'none') {
        //close all other utility navs
        closeUtilityNav();
        var heightToRemoveFromFullHeader = $(".mega-menu-wrapper").is(':visible') ? $(".mega-menu-wrapper").outerHeight() : 0;
        var fullHeaderHeight = $('.header-wrapper').is(':visible') ? $('.header-wrapper').outerHeight() : $('.site-header').outerHeight();
        dropdown.css("top", fullHeaderHeight - heightToRemoveFromFullHeader);
        dropdown.css("display", "flex");
        dropdown.css("flex-direction", "column");
        dropdown.css("justify-content", "flex-start");

        accountWrap.addClass("active");
    } else {
        closeUtilityNav();
    }

    if (dropdown.find(".closeUtilityNav").length > 0) {
        dropdown.find(".closeUtilityNav")[0].tabIndex = 0;
    }

    if (dropdown.find(".subUtility").length > 0) {
        for (var i = 0; i < dropdown.find(".subUtility").length; i++) {
            dropdown.find(".subUtility")[i].tabIndex = 0;
        }
    }
}

function closeUtilityNav() {
    $("#utilityNav").find('.dropdown').each(function () {
        if (this.style.display == 'flex') {
            this.style.display = 'none';
            $(this).closest('.account-wrap').removeClass("active");
        }
    });
}

function toggleUtilityNotifications(e) {
    var target = $(e.currentTarget)
    var dropdown = $("#utilityNav").find(".utility-nav-dropdown")
    var notifications = $("#utilityNav").find(".utility-notifications")
    var heightToRemoveFromFullHeader = $(".mega-menu-wrapper").is(':visible') ? $(".mega-menu-wrapper").outerHeight() : 0;
    var fullHeaderHeight = $('.header-wrapper').is(':visible') ? $('.header-wrapper').outerHeight() : $('.site-header').outerHeight();
    if (target.hasClass("active")) {
        target.removeClass("active")
        dropdown.css("max-height", "")
        notifications.css("max-height", "")
    } else {
        target.addClass("active")
        var calculatedDropdownHeight = "calc(100vh - " + ((fullHeaderHeight - heightToRemoveFromFullHeader) * 2) + "px)";
        dropdown.css("max-height", calculatedDropdownHeight)
        notifications.css("max-height", "none")
    }
}

// Reveal Sub-Overlay (for main nav)
$(".has-dropdown").click(function () {
    var subNavVisibleCss = { "left": "0", "top": "0" };
    $(this).find(".sub-overlay").css(subNavVisibleCss);
    $(this).closest("#fsNav").addClass("sub-item-open");

    if ($(this).find(".closeSubNav").length > 0) {
        $(this).find(".closeSubNav")[0].tabIndex = 0;
    }
    if ($(this).find(".subNav").length > 0) {
        for (var i = 0; i < $(this).find(".subNav").length; i++) {
            $(this).find(".subNav")[i].tabIndex = 0;
        }
    }
});

$('.secondary li').hover(function () {
    $(this).css('cursor', 'pointer');
});

$(".secondary li").click(function () {
    location.href = $(this).find("a").attr("href");
});

$(".closeSubNav").click(function() {
    $(".sub-overlay").css("left", "-1600px");
    for (var i = 0; i < $(".closeSubNav").length; i++) {
        $(".closeSubNav")[i].tabIndex = -1;
    }
    for (var j = 0; j < $(".subNav").length; j++) {
        $(".subNav")[j].tabIndex = -1;
    }
    $(this).closest("#fsNav").removeClass("sub-item-open");
    return false;
});

function closeNav() {
    // slide left
    document.getElementById("fsNav").style.left = "-1600px";
    document.body.style.overflow = "scroll";
    $(".closeNav").toggleClass('x no-x'); // Mobile
    $(".openNav").toggleClass('no-burger burger'); // Mobile
    $(".sub-overlay").css("left", "-1300px");

    //for accessibility
    $(".openNav").focus();
    $(".openNav").blur();

    document.getElementById("closeNavId").tabIndex = -1;
    for (var i = 0; i < $(".navSection").length; i++) {
        $(".navSection")[i].tabIndex = -1;
    }
    for (var j = 0; j < $(".subDirectLink").length; j++) {
        $(".subDirectLink")[j].tabIndex = -1;
    }
}

// Open/Close
$("body").on("click", ".openNav", openNav);
$("body").on("click", ".closeNav", closeNav);
$("body").on("click", ".utility-nav-item", openUtilityNav);
$("body").on("click", ".closeUtilityNav", closeUtilityNav);
$("body").on("click", ".utility-notifications-button", toggleUtilityNotifications);


// Close Nav (Click outside of Nav Overlay)
$(document).click(function(event) { 
    if (!$(event.target).closest('#fsNav').length) {
        var desktopNavOpen = $("#fsNav").css("left") == "0px" && $('header.mobile').css('display') === 'none';
        if (desktopNavOpen) {
            closeNav();
            $("#fsNav").removeClass("sub-item-open");
            return false;
        }
    }

    if (!$(event.target).closest('#utilityNav').length) {
        $("#utilityNav").find('.dropdown').each(function () {
            if (this.style.display == 'flex') {
                this.style.display = 'none';
            }
        });
    }
});
var MegaMenu = (function MegaMenu($) {
    var $component = $("body").find(".mega-menu-wrapper");
    var $hamburgerBtn = $("body").find(".hamburger");
    var $moreToggle;
    var $moreItemsWrapper = $component.find('.more-items-wrapper');

    function attachEvents() {
        var $megaMenuEl = $component.find(".collapsible-toggle:not(.more-toggle), .collapsible-panel");
        var $megaMenuToggle = $component.find(".collapsible-toggle");
        var $megamenuItem = $component.find(".collapsible-item");
        

        if ($(window).innerWidth() > 1024) {
            $megaMenuEl.on("mouseenter", function (e) {
                $(this).parents(".collapsible-item").addClass("active");
                if ($(e.target).closest(".more-items-wrapper").length === 0) {
                    $moreItemsWrapper.removeClass("active");
                }
                // if($moreItemsWrapper.hasClass('active')) {
                //     var megamenuWidht = $('body').outerWidth() - $moreItemsWrapper.outerWidth();
                //     var megamenuHeight =  $component.find('.collapsible-panel').outerHeight();

                //     $component.find('.collapsible-panel').css("width", `${megamenuWidht}px`);
                //     if(megamenuHeight > 340) {
                //         $component.find('.collapsible-panel').css("height",  megamenuHeight);
                //         $moreItemsWrapper.css("height",  megamenuHeight);
                //     }
                // } else {
                //     $component.find('.collapsible-panel').css("width", "100%");
                // }
            });

            $megaMenuEl.on("mouseleave", function () {
                $(this).parents(".collapsible-item").removeClass("active");
            });

            $(document).on('click', function (e) {
                if ($(e.target).closest(".mega-menu-wrapper").length === 0) {
                    $moreItemsWrapper.removeClass("active");
                }
            });

        } else {
            $megaMenuToggle.on("click", function () {
                if ($(this).parents(".collapsible-item").hasClass("active")) {
                    $(this).parents(".collapsible-item").removeClass("active");
                }
                else {
                    $megamenuItem.removeClass("active");
                    $(this).parents(".collapsible-item").addClass("active");
                }
            });
        }

    }

    function evalMenu() {
        var $megaMenu = $component.find(".mega-menu");
        var isMore = false;
        var $menuItems;
        var $menuItemsNot;
        var $menuItemsHide;
        var $moreItems;
        var moreToggle = "<li class='mega-menu__item priority'><button class='more-toggle collapsible-toggle'>More</button></li>";
        var moreItemsWrapper = "<div class='more-items-wrapper'></div>";
        var itemsWidth = 0;
        var lastItemWidth = 0;
      
        evalMenuItems();

        function evalMenuItems(){
            //evalItemsWidth();
            //if( itemsWidth > $megaMenu.outerWidth()) {
            //    if(!isMore) {
            //        $megaMenu.append(moreToggle);
            //        $megaMenu.append(moreItemsWrapper);
            //        isMore = true;
            //        $moreItemsWrapper = $component.find('.more-items-wrapper');
            //        $moreToggle = $component.find('.more-toggle');
            //        $moreToggle.on('mouseenter', function() {
            //            $moreItemsWrapper.addClass('active');
            //        });
            //    }
            //    lastItemWidth = $menuItemsNot.last().outerWidth();
            //    $menuItemsNot.last().clone().prependTo($moreItemsWrapper);
            //    $menuItemsNot.last().addClass('hide');
            //    redefineElements();
            //    evalToggle();
            //    attachEvents();
            //    evalMenuItems();
            //}
            //else if( lastItemWidth != 0 && itemsWidth + lastItemWidth < $megaMenu.outerWidth()) {
            //    $menuItemsHide.first().removeClass('hide');
            //    $moreItems.first().remove();
            //    redefineElements();
            //    evalToggle();
            //}
        }

        function redefineElements() {
            $menuItemsHide = $megaMenu.children(".mega-menu__item.hide");
            $moreItems = $moreItemsWrapper.children(".mega-menu__item");
        }

        function evalToggle() {
            if($moreItems.length == 0) {
                $moreToggle.hide();
            }
            else {
                $moreToggle.show();
            }
        }
        
        function evalItemsWidth(){
            $menuItems = $megaMenu.children(".mega-menu__item:not(.hide)");
            $menuItemsNot = $megaMenu.children(".mega-menu__item:not('.priority'):not(.hide)");
            itemsWidth = 0;
            $menuItems.each(function(){
                itemsWidth += $(this).outerWidth();
            });
        }

        $(window).resize(function() {
            if($(window).outerWidth() > 1190) {
                evalMenuItems();
                $megaMenu.css("display","flex");
                $component.find('.more-toggle').show();
            } else {
                $component.find(".collapsible-toggle-mobile ").removeClass("active");
                $megaMenu.removeAttr("style");
                $component.find('.more-toggle').hide();
                $component.find('.more-items-wrapper').removeClass("active");
            }

            $moreItemsWrapper.removeClass("active");
            $hamburgerBtn.removeClass("active");
        });
    }

    function init() {
        if (!$component.length) return;
        attachEvents();
        evalMenu();
    }

    return {
        init: init
    };

}(jQuery));

$(document).ready(function () {
    MegaMenu.init();
});

$(document).click(function (event) {
    if (!$(event.target).closest('#utilityNav').length) {
        $("#utilityNav").find('.dropdown').each(function () {
            if (this.style.display == 'flex') {
                this.style.display = 'none';
                // Remove active class from parent account-wrap
                $(this).closest('.account-wrap').removeClass("active");
            }
        });
    }
});